import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

function ThemeRefresh() {
  const { pathname } = useLocation()

  useEffect(() => {
    const refreshTheme = () => {
      if (window.AOS) {
        window.AOS.refreshHard?.()
        window.AOS.refresh()
      }
    }

    refreshTheme()
    const timer = window.setTimeout(refreshTheme, 150)

    return () => window.clearTimeout(timer)
  }, [pathname])

  return null
}

export default ThemeRefresh
